module.exports = "<template>\n\n    <sio-form config.bind=\"formConfiguration\" submit.call=\"submitInternal(object)\"></sio-form>\n\n</template>\n";